export default "__VITE_PUBLIC_ASSET__105330cb__"